import React from 'react'
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";
import Pizzeria from '@/components/outlet/Pizzeria';

const pizzeria = () => {
  return (
    <>
      <Head>
        <title> QueueBuster Pizzeria POS System: Efficient Billing & Management</title>
        <link rel="canonical" href="https://queuebuster.co/outlet/pizzeria" />
        <link rel="alternate" href="https://queuebuster.co/outlet/pizzeria" hrefLang="en-us" />
        <meta name="description" content="Revolutionize your pizzeria with QueueBuster’s POS system. Streamlined billing, inventory management, KOT, and online ordering. Boost efficiency & customer satisfaction!" />
        <meta property="og:title" content=" QueueBuster Pizzeria POS System: Efficient & Integrated Solution" />
        <meta property="og:description" content="Discover QueueBuster’s Pizzeria POS System tailored for pizza restaurants. Enjoy fast billing, precise inventory tracking, efficient KOT management, and seamless online ordering. Enhance your pizzeria’s efficiency and customer satisfaction with our all-in-one solution." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/OG%2BImages%2Bwebsite%2Bpages-07.jpg" />
        <meta property="og:url" content="https://queuebuster.co/outlet/pizzeria" />
      </Head>
         <SchemaTags page="pizzeria" />
      <Pizzeria />
    </>
  )
}

export default pizzeria